import React, { useState, useContext, useEffect } from 'react';
import {
  ResultForm,
  ResultFormRow,
  ResultButtonArea,
  ResultContent,
  ResultColumn,
  ResultResultItem,
  ResultResultItemIcon,
  ResultResultItemInfo,
  ResultDisplayResultLabel,
  ResultDisplayValues,
  ResultDisplayValuesRow,
  ResultDisplayValuesRowValue,
  ResultFooter,
  ResultFooterLeftSide,
  ResultFooterRightSide,
  Tooltip,
  TooltipTitle,
  TooltipContent,
  InfoCircleImage
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { TertiarySmallButton, DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { currencyMoney } from '../../../config/currency';
import { getTasas, getTasasFilter, getTasasPricing, isPricing } from '../../../services/tasas';
import { getSimulacionByIdCredito, postSimulationPricing } from '../../../services/simulation';
import Select from '../../../components/Select';
import FormTemplate from '../../../components/FormTemplate';
import Loader from '../../../components/Loader';
import InputIntl from '../../../components/InputIntl';
import InputDefault from '../../../components/InputDefault';
import SearchField from '../../../components/SearchField';
import ModalActionCongratulations from '../../../components/ModalActionCongratulations';
import { H6 } from '../../../components/Typography/styles';
import colors from '../../../assets/styles/colors';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { BsCheck, BsChevronBarUp, BsExclamation, BsPersonCheck } from 'react-icons/bs';
import { IoWalletOutline } from 'react-icons/io5';
import { BiBasket } from 'react-icons/bi';
import { useHistory, useLocation } from 'react-router-dom';
import { DataSolicitationContext } from '../../../store';
import { default as DataSolicitationTypes } from '../../../store/DataSolicitation/types';
import { creditLinesBack, credits, dataSolicitationSteps } from "../../../helpers/enum";
import { postSimulation } from '../../../services/simulation';
import { formatPrice } from '../../../helpers/price';
import { Form, FormRow } from '../../../components/FormTemplate/styles';
import { postDataSolicitation } from '../../../services/dataSolicitation';
import infoCircle from '../../../assets/images/info-circle.svg';
import { skipException, verifyException } from '../../../services/exceptions';
import { getSolicitationById } from "../../../services/solicitations";
import { getContractTypes, getExtracts } from '../../../services/extract';
import ModalInfo from '../../../components/ModalInfo';
import { getActivitiesPorIdPagaduria } from '../../../services/actividades';
import { getPaymentBill } from '../../../services/paymentbill';
import { getPiloto } from '../../../services/desk';


const OldResultPage = ({ setActiveStep }) => {
  const location = useLocation();
  const history = useHistory();
  const { dataSolicitation, setDataSolicitation } = useContext(DataSolicitationContext);
  const { register, setValue, control, watch, errors, clearErrors, handleSubmit } = useForm({ defaultValues: '' });
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState(null);
  const [paymentBill, setPaymentBill] = useState([]);
  const [filteredPaymentBill, setFilteredPaymentBill] = useState([]);
  const [showPaymentBill, setShowPaymentBill] = useState(false);
  const [tasas, setTasas] = useState([]);
  const [showTasa, setShowTasa] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const fields = watch();
  const [showExtracts, setShowExtracts] = useState(false);
  const [extracts, setExtracts] = useState([]);
  const [showContractType, setShowContractType] = useState(false);
  const [contractTypes, setContractsType] = useState([]);
  const [simulatorOne, setSimulatorOne] = useState(false);
  const [showModalInfoProduct, setShowModalInfoProduct] = useState(false);
  const [messageErrorProduct, setMessageErrorProduct] = useState('');
  const [titleErrorProduct, setTitleErrorProduct] = useState('');
  const [pilotoCambioEstados, setPilotoCambioEstados] = useState(false);

  async function initializedStateComponent() {
    try {
      //const tasas = await getTasas(); Modelo anterior
      setIsLoading(true);
      const solicitationResponse = await getSolicitationById(location.idCredit);
      let depto = solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[0] + '>' + solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[1];
      setInitiarDiasIniciales();
      const simulacionBD = await getSimulacionByIdCredito(location.idCredit);
      const extractResponse = await getExtracts();
      setExtracts(extractResponse.data);

      const isPilotoCambioEstados = await getPiloto(dataSolicitation.credit.idOficina);
      setPilotoCambioEstados(isPilotoCambioEstados.data.isNuevaUbicacionSimulador)
      

      /*const paymentBill = await getPaymentBill();
      setPaymentBill(paymentBill.data);
      setSelectedPaymentBill(dataSolicitation.solicitation.pagaduria)*/

      if (dataSolicitation.pricing) {
        getProductPricing();
      } else {
        const tasas = await getTasasFilter(dataSolicitation.credit.idPagaduria, depto);
        setTasas(tasas.data);
      }

      if (simulacionBD === null || simulacionBD === undefined) {
        fields.monto = 0;
        setValue("monto", fields.monto);
        fields.plazo = 0;
        setValue("plazo", fields.plazo);
        fields.diasInteresesIniciales = 0;
        setValue("diasInteresesIniciales", fields.diasInteresesIniciales);
      } else {
        fields.monto = simulacionBD.data["monto"] === null ? 0 : simulacionBD.data["monto"];
        setValue("monto", fields.monto);
        fields.plazo = simulacionBD.data["plazo"] === null ? 0 : simulacionBD.data["plazo"];
        setValue("plazo", fields.plazo);
        fields.diasInteresesIniciales = simulacionBD.data["diasInteresesIniciales"] === null ? 0 : simulacionBD.data["diasInteresesIniciales"];
        setValue("diasInteresesIniciales", fields.diasInteresesIniciales);
        if (simulacionBD.data["tasa"] !== null) {
          fields.tasa = tasas.data.find(({ nombre }) => nombre.indexOf(simulacionBD.data["tasa"]) !== -1);
          setValue("tasa", fields.tasa.nombre);
          setDataSolicitation({
            type: DataSolicitationTypes.SET_RATE,
            tasa: fields.tasa
          });
          clearErrors("tasa", {});
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  function setSelectedTasa(tasa) {
    setValue("tasa", tasa.nombre);
    clearErrors("tasa", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_RATE,
      tasa: tasa
    })

    if (dataSolicitation.pricing) {
      setDataSolicitation({
        type: DataSolicitationTypes.SET_TASA,
        rate: tasa.id
      })
    }
  }
  function setInitiarDiasIniciales() {
    setValue("diasInteresesIniciales", 120);
    clearErrors("diasInteresesIniciales", {});
  }

  async function setCalculate() {
    try {
      setIsLoading(true);
      setShowResult(false);

      const walletFields = dataSolicitation.creditData.fields.map(item => {
        return {
          idCompetidor: item.entidad.id,
          monto: item.monto,
          valorCuota: item.valorCuota,
          fechaVencimiento: item.fechaVencimiento,
          noObligacion: item.noObligacion,
        }
      });

      const req = {
        idPagaduria: dataSolicitation.credit.idPagaduria,
        idLineaCredito: dataSolicitation.creditData.lineaCredito.idBackend,
        idOficina: dataSolicitation.credit.idOficina,
        actividadCliente: dataSolicitation.credit.actividad || '',
        tasa: parseFloat(fields.tasa.replace('% ', '')),
        plazo: parseInt(fields.plazo),
        monto: parseInt(fields.monto),
        diasInteresesIniciales: parseInt(fields.diasInteresesIniciales),
        ingresos: parseInt(dataSolicitation.creditData.ingresos),
        cliente: {
          identificacion: dataSolicitation.credit.cliente.identificacion.replaceAll('.', ''),
          fechaNacimiento: dataSolicitation.credit.cliente.fechaNacimiento
        },
        descuentosLey: parseInt(dataSolicitation.creditData.descuentosLey),
        descuentosNomina: parseInt(dataSolicitation.creditData.descuentosNomina),
        carteras: [],
        departamento: null,
        genero: dataSolicitation.basicData.genero,
        nivelEducativo: dataSolicitation.basicData.educacion,
        tipoContrato: dataSolicitation.basicData.tipoContrato?.nombre,
        productPricing: dataSolicitation.creditData.pricingProduct,
        totalActivos: dataSolicitation.basicData.totalActivos,
        estrato: dataSolicitation.basicData.estrato?.nombre,
      }

      if (req.departamento === null || req.departamento === undefined) {
        const solicitationResponse = await getSolicitationById(location.idCredit);
        req.departamento = solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[0] + '>' + solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[1];
      }

      if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[1].id || dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) {
        req.carteras = walletFields;
      }

      if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id || dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) {
        req.idCreditoPadre = getListofCredits().map(credito => credito.id)
      }

      const response = await postSimulation(req);
      setResultData(response.data);
      setShowResult(true);


      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function getListofCredits() {
    return (dataSolicitation.creditData.credits.length === undefined) ? [dataSolicitation.creditData.credits] : dataSolicitation.creditData.credits;
  }

  function setBackStep() {
    setActiveStep(dataSolicitationSteps.CREDIT_DATA)
  }

  async function saveDataSolicitation() {
    try {
      setIsLoading(true);
      if(parseInt(resultData.montoMaximoSugerido) > parseInt(resultData.montoTotalCredito)){
      const walletFields = dataSolicitation.creditData.fields.map(item => {
        return {
          idCompetidor: item.entidad.id,
          monto: item.monto,
          valorCuota: item.valorCuota,
          fechaVencimiento: item.fechaVencimiento,
          noObligacion: item.noObligacion,
        }
      });

      console.log("Location: "+JSON.stringify(location));

      if (checkCapacity()) {
        const data = {
          idCredito: location.idCredit,
          idLineaCredito: dataSolicitation.creditData.lineaCredito.idBackend,
          idPagaduria: dataSolicitation.solicitation.pagaduria.id,
          idOficina: dataSolicitation.credit.idOficina,
          actividadCliente: dataSolicitation.basicData.actividadCliente?.id || '',
          tasa: parseFloat(fields.tasa.replace('% ', '')),
          plazo: parseInt(fields.plazo),
          monto: parseInt(fields.monto),
          diasInteresesIniciales: parseInt(fields.diasInteresesIniciales),
          ingresos: parseInt(dataSolicitation.creditData.ingresos),
          descuentosNomina: parseInt(dataSolicitation.creditData.descuentosNomina),
          descuentosLey: parseInt(dataSolicitation.creditData.descuentosLey),
          cliente: {
            identificacion: dataSolicitation.credit.cliente.identificacion,
            fechaNacimiento: dataSolicitation.credit.cliente.fechaNacimiento
          },
          carteras: [],
          departamento: null,
          genero: dataSolicitation.basicData.genero,
          nivelEducativo: dataSolicitation.basicData.educacion,
          tipoContrato: dataSolicitation.basicData.tipoContrato?.nombre,
          productPricing: dataSolicitation.creditData.pricingProduct,
          totalActivos: dataSolicitation.basicData.totalActivos,
          estrato: dataSolicitation.basicData.estrato?.nombre,
          idAsesor: dataSolicitation.basicData.idAsesor,
        }

        if (data.departamento === null || data.departamento === undefined) {
          const solicitationResponse = await getSolicitationById(location.idCredit);
          data.departamento = solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[0] + '>' + solicitationResponse.data.cliente.idCiudadExpedicionIdentificacion.split('>')[1];
        }

        if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[1].id || dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) {
          data.carteras = walletFields;
        }

        if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id || dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) {
          data.idCreditoPadre = ((dataSolicitation.creditData.credits.length === undefined) ? [dataSolicitation.creditData.credits] : dataSolicitation.creditData.credits).map(credito => credito.id)
        }

        await postDataSolicitation(data, "WEB");
        setIsLoading(false);
        setShowSuccessModal(true);
      }
      }else{
        setIsLoading(false);
        setTitleErrorProduct('La capacidad del cliente es inferior al valor de la cuota')
        setShowModalInfoProduct(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.response);
    }
  }



  function searchInPaymentBill(e) {
    setShowPaymentBill(true);
    let filtered = paymentBill.filter(paymentBill => paymentBill.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredPaymentBill(filtered);
  }

  async function setSelectedPaymentBill(paymentBill) {
    setValue("pagaduria", paymentBill.nombre);
    clearErrors("pagaduria", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_PAYMENT_BILL,
      pagaduria: paymentBill
    })

    if (!dataSolicitation.pricing) {
      await updateTasa(dataSolicitation.solicitation.pagaduria?.id, dataSolicitation.solicitation.cliente?.idDepartamento);
    }
    setShowPaymentBill(false);
  }

  function setInitiarDiasIniciales() {
    setValue("diasInteresesIniciales", 120);
    clearErrors("diasInteresesIniciales", {});
  }

  function canUseSelectRate() {
    return dataSolicitation.solicitation.pagaduria?.nombre;
  }

  async function updateTasa(pagaduria, departamento) {
    var response = await getTasasFilter(pagaduria, departamento);
    if (response.data) {
      const tasa = response.data.find(item => (item.id === dataSolicitation.creditData.tasa?.id || item.id == dataSolicitation.creditData.tasa));
      setSelectedTasa(tasa);
      setTasas(tasas);
    }
  }

  function checkCapacity() {
    return parseInt(resultData.remanenteEstimado) > 0 &&
      parseInt(resultData.montoMaximoSugerido) >= parseInt(resultData.remanenteEstimado);
  }

  function goToNextStep() {
    setShowSuccessModal(false);

    const data = {
      idCredito: location.idCredit
    }
    

    if(pilotoCambioEstados){
      history.push({
        pathname: '/admin/global-debit',
        idCredit: location.idCredit,
        client: location.client
      })
    }else{
      skipException(data);
      history.push({
        pathname: '/admin/ap-secure',
        idCredit: location.idCredit
      })
    }
  }



  useEffect(() => {
    setIsLoading(true);
    initializedStateComponent();
    setIsLoading(false);
    return () => {
      setTasas([]);
    }
  }, []);

  async function getProductPricing() {
    const req = {
      idCredito: location.idCredit,
      genero: dataSolicitation.basicData.genero,
      departamento: dataSolicitation.basicData.departamento,
      nivel_educativo: dataSolicitation.basicData.educacion,
      id_pagaduria: dataSolicitation.solicitation.pagaduria?.id,
      fecha_nacimiento: dataSolicitation.basicData.fechaNacimiento,
      tipo_contrato: dataSolicitation.basicData.tipoContrato?.nombre,
      nombre_pagaduria: dataSolicitation.solicitation.pagaduria?.nombre,
      total_activos: dataSolicitation.basicData.totalActivos,
      descuentos_nomina: dataSolicitation.creditData.descuentosNomina
    }
    setSimulatorOne(false);

    const response = await getTasasPricing(req, simulatorOne);
    const rates = response.data.rates;
    const ratesWithSymbol = rates.map(rate => ({
      id: rate,
      nombre: rate + '%',
    }))

    setTasas(ratesWithSymbol);
    //setValue("groupNumber",response.data.groupNumber);

    if(!response.data.enabled){
      setMessageErrorProduct(response.data.message);
      setShowModalInfoProduct(true);
      setTitleErrorProduct('Vigencia del grupo #')
    }

    setDataSolicitation({
      type: DataSolicitationTypes.SET_PRODUCT,
      pricingProduct: {
        rate: response.data.rate,
        suretyBond: response.data.suretyBond,
        creditStudy: response.data.creditStudy,
        productGroupId: response.data.productGroupId,
        deterioration: response.data.deterioration,
        rates: response.data.rates,
        groupNumber: response.data.groupNumber
      }
    })


  }

  return (
    <FormTemplate
      idForm="result-step-page"
      activeStep="4/4"
      stepLabel="Pre-aprobado">
      <Form onSubmit={handleSubmit(setCalculate)}>
        <ResultForm>
          <FormRow col="2">
          {!dataSolicitation.pricing && 
          <SearchField
          label="Pagaduría"
          name="pagaduria"
          id="pagaduria"
          show={showPaymentBill}
          list={filteredPaymentBill}
          defaultValue={dataSolicitation.solicitation.pagaduria?.nombre}
          selectField={setSelectedPaymentBill}
          searchInList={searchInPaymentBill}
          register={register({ required: "Este dato es obligatorio" })}
          error={errors.pagaduria}
          placeholder="Buscar..." />
          }
          </FormRow>
          <FormRow>
          <Select
              error={errors.tasa}
              setShow={setShowTasa}
              show={showTasa}
              defaultValue={fields.tasa}
              setSelected={setSelectedTasa}
              list={tasas}
              placeholder={canUseSelectRate() ? "Seleccionar..." : "Ingrese todos los datos para continuar..."}
              label="Tasa %"
              name="tasa"
              id="tasa"
              register={register({ required: "Este dato es obligatorio" })} />
               <InputIntl
              id="monto"
              label="Monto solicitado"
              error={errors.monto}
              name="monto"
              defaultValue={fields.monto}
              setValue={setValue}
              currencyConfig={currencyMoney}
              onBlur={() => { }}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 1,
                  message: "Este dato es obligatorio"
                }
              })} />
          </FormRow>
          {/*pricing &&
          <ResultFormRow>
            <InputDefault
            aria-required
            type="number"
            label="Grupo MP"
            name="groupNumber"
            register={register({ required: "Este dato es obligatorio" })}
            placeholder="Días"
            id="groupNumber"
            error={errors.groupNumber}
            maxLength="3"
            readOnly={true}
          />
            </ResultFormRow>*/ }
          
          <ResultFormRow>
            <Controller
              as={InputDefault}
              control={control}
              type="number"
              label="Plazo en meses"
              name="plazo"
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Meses"
              id="plazo"
              error={errors.plazo} />
            <Controller
              as={InputDefault}
              control={control}
              aria-required
              type="number"
              label="Días intereses Iniciales"
              name="diasInteresesIniciales"
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Días"
              id="diasInteresesIniciales"
              error={errors.diasInteresesIniciales}
              maxLength="3"
              readOnly={true}
            />
          </ResultFormRow>

        </ResultForm>
        <ResultButtonArea>
          <TertiarySmallButton type="submit" id="calculate">Calcular</TertiarySmallButton>
        </ResultButtonArea>
      </Form>
      {showResult && (
        <ResultContent>
          <ResultColumn>
            <ResultResultItem>
              <ResultResultItemIcon background={colors.grayLight}>
                <FaRegMoneyBillAlt color={colors.textPrimary} size={28} />
              </ResultResultItemIcon>
              <ResultResultItemInfo>
                <H6 color={colors.textPrimary}>Valor total crédito</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(resultData.montoTotalCredito))}</H6>
              </ResultResultItemInfo>
            </ResultResultItem>
            <ResultResultItem>
              <ResultResultItemIcon background={checkCapacity() ? colors.bgSecondary : colors.bgDanger}>
                <BsChevronBarUp color={colors.white} size={28} />
              </ResultResultItemIcon>
              <ResultResultItemInfo>
                <H6 color={colors.textPrimary}>Monto máximo sugerido</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(resultData.montoMaximoSugerido))}</H6>
              </ResultResultItemInfo>
            </ResultResultItem>
            <ResultResultItem>
              <ResultResultItemIcon background={colors.grayLight}>
                <IoWalletOutline color={colors.textPrimary} size={28} />
              </ResultResultItemIcon>
              <ResultResultItemInfo>
                <H6 color={colors.textPrimary}>Cuota corriente</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(resultData.cuotaCorriente))}</H6>
              </ResultResultItemInfo>
            </ResultResultItem>
            <ResultResultItem>
              <ResultResultItemIcon background={colors.grayLight}>
                <BiBasket color={colors.textPrimary} size={28} />
              </ResultResultItemIcon>
              <ResultResultItemInfo>
                <H6 color={colors.textPrimary}>Remanente estimado</H6>
                <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(resultData.remanenteEstimado))}</H6>
              </ResultResultItemInfo>
            </ResultResultItem>
            <ResultResultItem>
              <ResultResultItemIcon background={colors.grayLight}>
                <BsPersonCheck color={colors.textPrimary} size={28} />
              </ResultResultItemIcon>
              <ResultResultItemInfo>
                <H6 color={colors.textPrimary}>Edad</H6>
                <H6 color={colors.textPrimary} semibold>{resultData.cliente.edadCliente} años</H6>
              </ResultResultItemInfo>
            </ResultResultItem>
          </ResultColumn>
          <ResultColumn>
            <ResultDisplayResultLabel>Descuentos</ResultDisplayResultLabel>
            <ResultDisplayValues>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>Estudio crédito + IVA</ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {formatPrice(parseInt(resultData.estudioCreditoMasIVA))}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>Valor intereses iniciales (CxC)</ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {formatPrice(parseInt(resultData.valorInteresesIniciales))}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>
                  Valor de la fianza
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                </ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {resultData.valorFianza !== 'null' ? formatPrice(parseInt(resultData.valorFianza)) : formatPrice(0)}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
              {/* <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>Interés de fianza</ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ 0</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow> */}
            </ResultDisplayValues>
            {/*<ResultDisplayResultLabel>Descuentos</ResultDisplayResultLabel>*/}
            <ResultDisplayValues>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>GMF (4 X 1.000)</ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {formatPrice(parseInt(resultData.gmf))}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>
                  Valor compras a girar
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                </ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {formatPrice(parseInt(resultData.valorComprasSaneamientos))}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
              <ResultDisplayValuesRow>
                <ResultDisplayValuesRowValue>
                  Prima anticipada de seguro
                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                </ResultDisplayValuesRowValue>
                <ResultDisplayValuesRowValue>$ {formatPrice(parseInt(resultData.primaAnticipadaSeguro))}</ResultDisplayValuesRowValue>
              </ResultDisplayValuesRow>
            </ResultDisplayValues>
            <Tooltip
              id='tooltip-fianza'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor de la fianza
              </TooltipTitle>
              <TooltipContent>
                Corresponde a un % que se calcula sobre el valor a asegurar y funciona como una figura de “fiador” que respalda la deuda.
              </TooltipContent>
            </Tooltip>
            <Tooltip
              id='tooltip-prima'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Prima anticipada de seguro
              </TooltipTitle>
              <TooltipContent>
                Es el cobro anticipado de 24 meses de seguro que se descuenta al cliente sobre el valor del desembolso.
              </TooltipContent>
            </Tooltip>
            <Tooltip
              id='tooltip-compras'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor compras a girar
              </TooltipTitle>
              <TooltipContent>
                Corresponde al valor de las compras de cartera.
              </TooltipContent>
            </Tooltip>
          </ResultColumn>
        </ResultContent>
      )}

      {isLoading && <Loader />}

      <ResultFooter>
        <ResultFooterRightSide>
          <ResultDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</ResultDisplayValuesRowValue>
        </ResultFooterRightSide>
      </ResultFooter>
      <ResultFooter>
        <ResultFooterLeftSide>
          <DefaultLargeButton type="button" onClick={() => setBackStep()} id="back-step">Volver</DefaultLargeButton>
        </ResultFooterLeftSide>
        <ResultFooterRightSide>
          <SecondaryLargeButton type="button" onClick={() => saveDataSolicitation()} id="save-simulation" disabled={!showResult}>Siguiente</SecondaryLargeButton>
        </ResultFooterRightSide>
      </ResultFooter>

      <ModalActionCongratulations
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => goToNextStep()}
        title="¡Felicitaciones!"
        actionLabelFunctionUpButton="Confirmar"
        description="La información del cliente ha sido validada exitosamente, continúa con el proceso de crédito."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
         <ModalInfo
        open={showModalInfoProduct}
        setShowModal={setShowModalInfoProduct}
        title={titleErrorProduct}
        description={messageErrorProduct}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    </FormTemplate>
  )
}

export default OldResultPage;
